import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { Legal } from './pages/Legal';
import { ScrollToHash } from './components/ScrollToHash';
type OfferId = 'single' | 'trio' | 'crew';
interface AppProps {
  showAnnouncementBar?: boolean;
  defaultOffer?: OfferId;
}
export function App({
  showAnnouncementBar = true,
  defaultOffer = 'trio'
}: AppProps) {
  return <BrowserRouter data-id="element-0" data-mp="2rlyoa9krccgv">
      <ScrollToHash data-id="element-1" data-mp="2rl6un4aq0ot8" />
      <Routes data-id="element-2" data-mp="2riknh5rqsbbj">
        <Route path="/" element={<Home showAnnouncementBar={showAnnouncementBar} defaultOffer={defaultOffer} data-id="element-4" data-mp="2mn5aeg1k6jg6" />} data-id="element-3" data-mp="2mm2mmgzj8x4h" />
        <Route path="/legal/:slug" element={<Legal data-id="element-6" data-mp="31cjmvx0flgzs" />} data-id="element-5" data-mp="31bi9hlvy0iew" />
        <Route path="*" element={<Legal data-id="element-8" data-mp="2wjqff1dkvuk0" />} data-id="element-7" data-mp="2wka20ve6b74d" />
      </Routes>
    </BrowserRouter>;
}